import { useInfiniteQuery } from '@zg-rentals/react-query5';

import { transformFiltersToApiParams } from './zram';

import type { GroupablePropertiesListResponseDto } from '../../types/GroupablePropertiesListDto';
import type { FilterState } from '../../containers/ZRAMPropertiesPage';

export const useGetGroupablePropertiesData = (filters: FilterState) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isPending, isError, isFetching } = useInfiniteQuery<
    GroupablePropertiesListResponseDto,
    Error,
    { pages: Array<GroupablePropertiesListResponseDto> },
    Array<string | FilterState>,
    string
  >({
    queryKey: ['getGroupableProperties', filters],
    queryFn: async ({ pageParam }) => {
      // TODO: Replace with real v2 endpoint when available
      const { mockRentalManagerAccountViewZrmWebApiHandlerV2_list } = await import(
        '../../api/mockGroupablePropertiesListApi'
      );
      return mockRentalManagerAccountViewZrmWebApiHandlerV2_list({
        ...transformFiltersToApiParams(filters),
        startGroupIdExclusive: pageParam,
      });
    },
    initialPageParam: '',
    getNextPageParam: (lastPage) => (lastPage.pager?.hasMore ? lastPage.pager.endGroupId : undefined),
    // Keep previous data during refetch to prevent UI flicker
    placeholderData: (previousData) => {
      if (!previousData?.pages?.length) {
        return;
      }

      return previousData;
    },
  });

  const propertiesData = data?.pages.length
    ? {
        listingGroups: data.pages.flatMap((page) => page.listingGroups),
        listingCount: data.pages[0].listingCount,
        pager: data.pages[data.pages.length - 1].pager,
      }
    : {};

  return {
    data: propertiesData,
    isPending,
    isFetching,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
};
